const FeedbackDataSelector = ({ annualFeedbackData: { FeedbackData } }) =>
  FeedbackData;

export default FeedbackDataSelector;
